import { EveFooter } from '@ver-uds/e-verify';
import { GlobalHeader, PageHeader } from '@ver-uds/react';
import { SkipNav } from '@ver-uds/uswds-react';
import classNames from 'classnames';
import React, { ReactNode } from 'react';
import { Helmet } from 'react-helmet-async';
import logo from './logo.png';

export interface ClientMouWrapperProps {
  children: ReactNode;
  title: string;
  header?: string;
  hideSkipNav?: boolean;
}

const ClientMouWrapper = ({ children, header, title, hideSkipNav = false }: ClientMouWrapperProps): JSX.Element => (
  <>
    <GlobalHeader logo={<img src={logo} alt="E-Verify logo" />} />
    <Helmet>
      <title>{title}</title>
    </Helmet>
    {header && <PageHeader>{header}</PageHeader>}
    <div className={classNames({ 'grid-container': !hideSkipNav, 'maxw-none': hideSkipNav })}>
      <SkipNav.MainContent>{children}</SkipNav.MainContent>
    </div>
    <EveFooter />
  </>
);
export default ClientMouWrapper;
